export default "__VITE_ASSET__BEwp7_PV__"